export default {
  name: 'marking--eanInfo',
  apiService: 'shoes',
  apiPath: '/admin/ean_info',
};